import { defineComponent, ref } from "vue";
import { api } from "~/api/index";
import { MsgBox } from "~/components/MsgBox";
import { Log } from "~/extensions/utils";
import { commonStore } from "~/store/CommonStore";
const log = Log.create("TaikyoForInputArea");
export default defineComponent({
    name: "BankDialog",
    emits: ["close", "select"],
    setup(props, { emit }) {
        const allBankList = ref([]);
        const displayBankList = ref([]);
        const searchBank = ref("");
        const isLoading = ref(false);
        const closeDialog = () => {
            emit("close");
        };
        const onRowClick = (bank) => {
            emit("select", bank);
        };
        const onSearch = async () => {
            if (allBankList.value.length === 0) {
                await MsgBox.error(commonStore.messages.PE0001);
                return;
            }
            const text = searchBank.value.trim();
            if (text === "") {
                displayBankList.value = [];
            }
            else {
                displayBankList.value = allBankList.value.filter(bank => bank.name.includes(text));
            }
        };
        const initView = async () => {
            try {
                isLoading.value = true;
                const result = await api.common.findBank();
                allBankList.value = result;
                displayBankList.value = allBankList.value.filter(bank => ["0005", "0009", "0001", "0010", "0017"].includes(bank.code));
            }
            catch (ex) {
                log.error("setup", ex);
                await MsgBox.error(commonStore.messages.PE0001);
            }
            finally {
                isLoading.value = false;
            }
        };
        initView();
        return {
            allBankList,
            displayBankList,
            searchBank,
            onSearch,
            onRowClick,
            closeDialog,
            isLoading
        };
    }
});
